const BACKEND_URL = process.env.REACT_APP_API_URL;  
const API_URL = `${BACKEND_URL}/users`;

const verifyEmail = async (email, code, role) => {
  let url = `${API_URL}/verify-code`;
  if (role === 'Guide') {
    url = `${BACKEND_URL}/api/verify-code`;
  }

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, code }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Email verification failed");
  }

  return response.json();
};

export { verifyEmail };
